import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router";
import { useRecoilState } from 'recoil';
import ReactTooltip from "react-tooltip";
import { AiFillFacebook, AiFillInstagram, AiFillTwitterSquare, AiFillYoutube, AiOutlineGlobal } from 'react-icons/ai';
import { FaYoutubeSquare } from 'react-icons/fa';
import { MdCheckBox } from 'react-icons/md';
import api from '~/services/api';
import { BASEURL } from '~/helpers/constantes';
import Modal from '~/components/modal/Modal';
import { InputCheck, ButtonPadraoPrimary } from '~/styles/CommonStyles';
import getUrlParameter from '~/helpers/getURLencode';
import { removeToken } from "../../services/managerToken";
import Toastify from "~/components/Toastify";
import {
    Container,
    ContainerHeader,
    ContainerBody,
    ContainerIconSoftware,
    ContainerItensMenu,
    ContainerIconesSociais,
    ContainerTermo,
} from './styles';

// import { textState } from '../../atoms/text';
import { conformidadeLGPD, mensagemConformidadeLGPD } from '../../atoms/conformidade';

const Menu = ( { children, history, location } ) => {
    // const _CHAVE = getUrlParameter( 'chave', location.search );
    const params = new URLSearchParams( location.search );
    const _CHAVE = params.get( 'chave' );
    const [ dadosClinica, setDadosClinica ] = useState( { Logotipo: '' } );
    const [ conformidade, setConformidade ] = useRecoilState( conformidadeLGPD );
    const [ conformidadeMensagem, setConformidadeMensagem ] = useRecoilState( mensagemConformidadeLGPD );


    async function getDados () {
        try {
            const response = await api.post( `apoio/getpropriedadesdoapoio`, { chave: _CHAVE } );
            setDadosClinica( response.data );

        } catch ( error ) {
            console.log( error );
        }
    };

    useEffect( () => {
        getDados();
    }, [] );


    return (
        <Container >
            <ContainerHeader>
                <ContainerIconSoftware>

                </ContainerIconSoftware>
                <ContainerItensMenu style={ { width: '65px' } }>
                    <img src={ `${ BASEURL }${ dadosClinica.Logotipo }` } onError={ () => setDadosClinica( { ...dadosClinica, Logotipo: '/medxdata/2087/marketing/logoMEDXlowres.jpg' } ) } style={ { height: '100%' } } />
                </ContainerItensMenu>

                <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center' } }>
                    { dadosClinica.Facebook && <ContainerIconesSociais onClick={ () => window.open( `${ dadosClinica.Facebook }`, '_blank' ) }>
                        <AiFillFacebook />
                    </ContainerIconesSociais> }
                    { dadosClinica.Instagram && <ContainerIconesSociais onClick={ () => window.open( `${ dadosClinica.Instagram }`, '_blank' ) }>
                        <AiFillInstagram />
                    </ContainerIconesSociais> }
                    { dadosClinica.Twitter && <ContainerIconesSociais onClick={ () => window.open( `${ dadosClinica.Twitter }`, '_blank' ) }>
                        <AiFillTwitterSquare />
                    </ContainerIconesSociais> }
                    { dadosClinica.Youtube && <ContainerIconesSociais onClick={ () => window.open( `${ dadosClinica.Youtube }`, '_blank' ) }>
                        <FaYoutubeSquare />
                    </ContainerIconesSociais> }
                    { dadosClinica.Site && <ContainerIconesSociais onClick={ () => window.open( `${ dadosClinica.Site }`, '_blank' ) }>
                        <AiOutlineGlobal />
                    </ContainerIconesSociais> }

                </div>
            </ContainerHeader>
            <ContainerBody>
                { children }
            </ContainerBody>
            {/* conformidade.popUpOpen */ }
            <Modal largura={ '90vw' } altura={ '85%' } visibility={ conformidade.popUpOpen } close={ () => { setConformidade( { ...conformidade, popUpOpen: false } ); } } title="Conformidade de coleta de dados - LGPD">
                <div style={ { height: 'calc(100% - 90px)', overflowY:"auto", display: 'grid' } }>
                    <ContainerTermo>
                        <div>
                            <h2>Coleta de dados pessoais com a finalidade de atendimento médico</h2>
                            <span >
                                Em conformidade com a Lei Geral de Proteção de Dados (LGPD) Nº 13.709, de 14 de agosto de 2018,
                                seus dados pessoais informados são para uso exclusivo da clínica ou consultório responsável por este atendimento.
                                As informações coletadas tem a finalidade de interesse legítimo do paciente e a finalidade legal
                                por parte da clínica, assim como permitir o envio de comunicações entre a clínica e o paciente.
                                Estas informações estarão seguras no nosso banco de dados, seguindo as melhores práticas
                                de cibersegurança e proteção de dados, conforme definido na
                                <a href={ 'https://info.medx.med.br/politica-de-privacidade/' }> Política de privacidade</a>.
                            </span>
                        </div>
                    </ContainerTermo>
                    <ContainerTermo>
                        <div>
                            <h2>Coleta de dados pessoais com a finalidade de envio de e-mail marketing</h2>
                            <span style={ { marginLeft: '15px' } }>
                                Autoriza o recebimento de e-mail marketing, conforme a nossa
                               <a href={ 'https://info.medx.med.br/politica-de-privacidade/' }> Política de privacidade</a>?
                            </span>
                        </div>
                        <div style={ { marginLeft: '15px', display: 'flex', gap: '10px' } }>
                            <ButtonPadraoPrimary onClick={ () => setConformidade( { ...conformidade, dadosMarketing: true } ) }>
                                AUTORIZO
                                { conformidade.dadosMarketing && <MdCheckBox style={ { marginLeft: '20px' } } /> }
                            </ButtonPadraoPrimary>
                            <ButtonPadraoPrimary onClick={ () => setConformidade( { ...conformidade, dadosMarketing: false } ) } cancel>
                                NÃO AUTORIZO
                                { conformidade.dadosMarketing === false && <MdCheckBox style={ { marginLeft: '20px' } } /> }
                            </ButtonPadraoPrimary>
                        </div>
                    </ContainerTermo>
                    <ContainerTermo>
                        <div>
                            <h2>Coleta de dados pessoais com a finalidade de envio de SMS para campanhas de marketing</h2>
                            <span style={ { marginLeft: '15px' } }>
                                Autoriza o recebimento de SMS com as nossas campanhas de marketing,
                                conforme a nossa <a href={ 'https://info.medx.med.br/politica-de-privacidade/' }>Política de privacidade</a>?
                            </span>
                        </div>
                        <div style={ { marginLeft: '15px', display: 'flex', gap: '10px' } }>
                            <ButtonPadraoPrimary onClick={ () => setConformidade( { ...conformidade, dadosSMS: true } ) }>
                                AUTORIZO
                                { conformidade.dadosSMS && <MdCheckBox style={ { marginLeft: '20px' } } /> }
                            </ButtonPadraoPrimary>
                            <ButtonPadraoPrimary onClick={ () => setConformidade( { ...conformidade, dadosSMS: false } ) } cancel>
                                NÃO AUTORIZO
                                { conformidade.dadosSMS === false && <MdCheckBox style={ { marginLeft: '20px' } } /> }
                            </ButtonPadraoPrimary>
                        </div>

                    </ContainerTermo>
                    <ContainerTermo>
                        <ButtonPadraoPrimary onClick={ () => {
                            if ( conformidade.dadosSMS == null || conformidade.dadosMarketing === null )
                                return Toastify.warning( 'Por favor informe se esta de acordo com os envios de SMS e marketing.' );
                            setConformidade( { ...conformidade, popUpOpen: false, confirmado: true } );
                        } }>
                            Confirmar
                        </ButtonPadraoPrimary>
                    </ContainerTermo>
                </div>
            </Modal>

            <Modal styles={ { maxWidth: '800px' } } largura={ '90vw' } altura={ '80%' } visibility={ conformidadeMensagem.popUpOpen } close={ () => { setConformidadeMensagem( { popUpOpen: false } ); } } title="Conformidade de coleta de dados - LGPD">
                <div style={ { display: 'grid', height: "70%", overflowY: "auto" } }>
                    <ContainerTermo>
                        <h2>Coleta de dados pessoais com a finalidade de atendimento médico</h2>
                        <span >
                            Em conformidade com a Lei Geral de Proteção de Dados (LGPD) Nº 13.709, de 14 de agosto de 2018,
                            seus dados pessoais informados são para uso exclusivo da clínica ou consultório responsável por este atendimento.
                            As informações coletadas tem a finalidade de interesse legítimo do paciente e a finalidade legal
                            por parte da clínica, assim como permitir o envio de comunicações entre a clínica e o paciente.
                            Estas informações estarão seguras no nosso banco de dados, seguindo as melhores práticas
                            de cibersegurança e proteção de dados, conforme definido na
                            <a href={ 'https://info.medx.med.br/politica-de-privacidade/' }> Política de privacidade</a>.
                        </span>
                    </ContainerTermo>
                    <ContainerTermo style={ { alignItems: 'center' } }>
                        <ButtonPadraoPrimary onClick={ () => {
                            setConformidadeMensagem( { popUpOpen: false } );
                        } }>
                            Confirmar
                        </ButtonPadraoPrimary>

                    </ContainerTermo>

                </div>
            </Modal>
        </Container>
    );
};

export default withRouter( Menu );
